var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-article',[_c('div',{staticClass:"col-12 page_content_area"},[_c('div',{staticClass:"container"},[_c('recruitment-orientation-time-slots',{attrs:{"orientations":_vm.currentOrientationDetailsGetter,"read-only":""}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }